import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    {...props}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionTag = ({ children }) => (
  <p className="text-brand text-xs font-medium uppercase tracking-[0.35em] mb-6" data-testid="section-tag">
    {children}
  </p>
);
